// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 22H2V11H11V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 22H13V11H22V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.2334 2C12.7655 2.89763 12.5 3.91768 12.5 5C12.5 6.50876 13.0144 7.89709 13.877 9H2V2H13.2334Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.4551 3.54395L23.6797 5L20.4551 6.45508L19 9.67969L17.5439 6.45508L14.3203 5L17.5439 3.54395L19 0.320312L20.4551 3.54395Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-layout-filled')
export default class AiLayoutFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-layout-filled',
    }
  }
}
